<template>
    <div>
        <el-dialog v-if='baseRuleDoalog' :visible.sync='baseRuleDoalog' width="950px" @close='closeDialog' :close-on-click-modal="false">
            <el-steps :active="active" finish-status="success" align-center>
                <el-step title="第一步" description="发票类型设置"></el-step>
                <el-step title="第二步" description="不变项，精度设置"></el-step>
                <el-step title="第三步" description="拆分参数设置"></el-step>
            </el-steps>
            <el-form ref="form" :model="form" label-width="80px" style='padding: 20px;'>
                <div v-if='active == 0'>

                    <div style="margin-top: 20px;margin-left: 60px;" v-for='(item,index) in fplxOption' :key='index' class="Centerupdown">
                        <div style='width: 100px;'>
                            <el-checkbox :disabled="viewFlag" style='margin-top: 15px;'  :label="item.label" v-model='item.flag'></el-checkbox>
                        </div>

                        <div v-if='item.flag'>
                            <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                                <div>限额</div>
                                <el-select :disabled="viewFlag" v-model="form.stepOneArr[index].xiane" placeholder="请选择限额" style='margin-left: 20px;' @change='xianeChange($event,index)'>
                                    <el-option v-for='(item,index) in xianeSelectOption' :key='index' :label="item.label" :value="item.value"></el-option>
                                </el-select>
                                <el-switch :disabled="viewFlag" style='margin-left: 20px;'
                                           v-model="form.stepOneArr[index].hansjeType"
                                           active-color="#13ce66"
                                           inactive-color="#ff4949">
                                </el-switch>
                                <div style='margin-left: 20px;'>含税金额</div>
                                <div class="demo-input-size" style='margin-left: 20px;'>
                                    <el-input :disabled="viewFlag" v-model="form.stepOneArr[index].hansje" placeholder="请输入金额" size="medium"></el-input>
                                </div>
                            </div>
                            <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                                <div>限行</div>
                                <el-input-number :disabled="viewFlag" size="medium" style='margin-left: 20px;' v-model="form.stepOneArr[index].xzmxhs" :min="0" v-if="fplxOption[index].value == '004' || fplxOption[index].value == '007'" :max="fplxOption[index].value == '004' || fplxOption[index].value == '007' ? 8 : 10000" label="请输入限行"></el-input-number>
                                <el-input-number :disabled="viewFlag" size="medium" style='margin-left: 20px;' v-model="form.stepOneArr[index].xzmxhs" :min="0" v-else label="请输入限行"></el-input-number>
                                <el-switch :disabled="viewFlag" style='margin-left: 25px;' v-if="fplxOption[index].value == '004' || fplxOption[index].value == '007'"
                                           v-model="form.stepOneArr[index].qdbz"
                                           active-color="#13ce66"
                                           inactive-color="#ff4949">
                                </el-switch>
                                <div style='margin-left: 20px;' v-if="fplxOption[index].value == '004' || fplxOption[index].value == '007'">允许清单</div>
                                <el-input-number :disabled="!form.stepOneArr[index].qdbz || viewFlag" v-if="fplxOption[index].value == '004' || fplxOption[index].value == '007'" size="medium" style='margin-left: 20px;' v-model="form.stepOneArr[index].qdsl" :min="0" :max="2000" label="请输入清单行数"></el-input-number>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if='active == 1'>
                    <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                        <div style='width: 100px;'>价税不变项</div>
                        <div style='margin-left: 20px;'>
                            <el-radio :disabled="viewFlag" v-model="form.jsbbx" label="1">保持含税金额不变</el-radio>
                            <el-radio :disabled="viewFlag" v-model="form.jsbbx" label="2">保持不含税金额不变</el-radio>
                            <el-radio :disabled="viewFlag" v-model="form.jsbbx" label="3">保持税额不变</el-radio>
                        </div>
                    </div>
                    <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                        <div style='width: 100px;'>单价数量不变项</div>
                        <div style='margin-left: 20px;'>
                            <el-radio :disabled="viewFlag" v-model="form.djslbbx" label="1">保持单价不变</el-radio>
                            <el-radio :disabled="viewFlag" v-model="form.djslbbx" label="2">保持数量不变</el-radio>
                        </div>
                    </div>

                    <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                        <div style='width: 100px;'>数量精度</div>
                        <div style='margin-left: 20px;' class="Centerupdown">
                            <div>保留</div>
                            <el-input-number :disabled="viewFlag" style='margin-left: 15px; margin-right: 15px;' v-model="form.sljd" :min="0" :max="10" label="请输入保留位数"></el-input-number>
                            <div>小数</div>
                        </div>
                    </div>

                    <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                        <div style='width: 100px;'>单价精度</div>
                        <div style='margin-left: 20px;' class="Centerupdown">
                            <div>保留</div>
                            <el-input-number :disabled="viewFlag" style='margin-left: 15px; margin-right: 15px;' v-model="form.djjd" :min="1" :max="10" label="请输入保留位数"></el-input-number>
                            <div>小数</div>
                        </div>
                    </div>
                </div>
                <div v-if='active == 2'>
                    <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                        <div style='width: 100px;'>拆分细则一</div>
                        <el-checkbox :disabled="viewFlag" v-model="form.yxdslfp">允许多税率发票</el-checkbox>
                    </div>

                    <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                        <div style='width: 100px;'>拆分细则二</div>
                        <el-radio :disabled="viewFlag" v-model="form.cffs" label="1">按限额顶额拆分</el-radio>
                        <el-radio :disabled="viewFlag" v-model="form.cffs" label="2">按限额平均拆分</el-radio>
                    </div>

                    <div style="margin-top: 20px;margin-left: 60px;"  class="Centerupdown">
                        <div style='width: 100px;'>拆分细则三</div>
                        <el-checkbox :disabled="viewFlag" v-model="form.cfmxFlag" @change='cfmxFlagChange'>允许拆分明细</el-checkbox>
                    </div>

                    <div v-if='form.cfmxFlag' style="margin-top: 20px;margin-left: 200px;">
                        <el-checkbox-group v-model="form.cfmx" :disabled="viewFlag">
                            <div class="Centerupdown">
                                <div style='width: 200px;'>
                                    <el-checkbox label="1" >小类（商品名称）</el-checkbox>
                                </div>
                                <div style='width: 200px;'>
                                    <el-checkbox label="2">大类</el-checkbox>
                                </div>
                            </div>
                            <div class="Centerupdown" style='margin-top: 15px;'>
                                <div style='width: 200px;'>
                                    <el-checkbox label="3">规格型号</el-checkbox>
                                </div>
                                <div style='width: 200px;'>
                                    <el-checkbox label="4">单位</el-checkbox>
                                </div>
                            </div>
                        </el-checkbox-group>
                    </div>
                </div>
            </el-form>

            <div style='text-align: center; margin-top: 20px;'>
                <el-button v-if='active > 0'   style="margin-top: 12px; margin-bottom: 20px;"  @click="active--">上一步</el-button>
                <el-button v-if='active !=2' style="margin-top: 12px; margin-bottom: 20px;"  @click="nextStep">下一步</el-button>
                <el-button v-if='active ==2' style="margin-top: 12px; margin-bottom: 20px;"  @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'BaseRule',
    props:{
        baseRuleDoalog:{
            type:Boolean,
            default:false
        },
        baseRuleData:{
            type:Array,
            default: []
        },
        viewFlag:{
            type: Boolean,
            default:false,
        },
    },
    data(){
      return{
          active: 0,

          form:{
            stepOneArr:[
                {guizlxbh:"11",xiane:3, hansjeType:false, hansje:'99,999.99', xzmxhs:8, qdbz:true, qdsl:2000},
                {guizlxbh:"12",xiane:3, hansjeType:false, hansje:'99,999.99', xzmxhs:8, qdbz:true, qdsl:2000},
                {guizlxbh:"13",xiane:3, hansjeType:false, hansje:'99,999.99', xzmxhs:100, qdbz:true, qdsl:0},
                {guizlxbh:"14",xiane:3, hansjeType:false, hansje:'99,999.99', xzmxhs:100, qdbz:true, qdsl:0},
                // {xiane:'', hansjeType:true, hansje:'', xzmxhs:8, qdbz:true, qdsl:0},
                // {xiane:'', hansjeType:true, hansje:'', xzmxhs:8, qdbz:true, qdsl:0},
                // {xiane:'', hansjeType:true, hansje:'', xzmxhs:8, qdbz:true, qdsl:0},
                // {xiane:'', hansjeType:true, hansje:'', xzmxhs:8, qdbz:true, qdsl:0}
            ],

            jsbbx:'1',
            djslbbx:'2',
            sljd:6,
            djjd:6,

            yxdslfp:true,
            cffs:'1',
            cfmxFlag:true,
            cfmx:["1","2"],

          },

          xianeSelectOption:[
              {label:"千元版（不含税 999.99）",value:1, text:'999.99'},
              {label:"万元版（不含税 9,999.99）",value:2, text:'9,999.99'},
              {label:"十万元版（不含税 99,999.99）",value:3, text:'99,999.99'},
              {label:"百万元版（不含税 999,999.99）",value:4, text:'999,999.99'},
              {label:"千万元版（不含税 9,999,999.99）",value:5, text:'9,999,999.99'},
              {label:"数电发票版（不限税额）",value:6, text:'0'},
          ],
          fplxOption:[
              {label:"纸质专票",value:"004",flag:false},
              {label:"纸质普票",value:"007",flag:false},
              {label:"电子专票",value:"028",flag:false},
              {label:"电子普票",value:"026",flag:false},
              // {label:"数电纸质专票",value:"1",flag:false},
              // {label:"数电纸质普票",value:"2",flag:false},
              // {label:"数电电子专票",value:"3",flag:false},
              // {label:"数电电子普票",value:"4",flag:false},
          ],
      }
    },
    watch:{
        baseRuleDoalog:function(){
           if (this.baseRuleDoalog) {
               this.editData();
           }
        }
    },
    created() {
        this.editData();
    },
    methods:{
        editData(){
            if (this.baseRuleData.length > 0) {
                this.baseRuleData.forEach(item => {
                    this.fplxOption.forEach((option,index) => {
                        if (option.value == item.fplxs) {
                            option.flag = true;
                            this.form.stepOneArr[index].hansje = this.numFormat(item.hansje);
                            // this.form.stepOneArr[index].xiane = this.xianeSelectOption.filter(select => select.text == this.form.stepOneArr[index].hansje)[0].label;
                            this.form.stepOneArr[index].xzmxhs = item.xzmxhs;
                            this.form.stepOneArr[index].qdsl = item.qdsl;
                            this.form.stepOneArr[index].xiane = item.xebz != null && item.xebz != '' ? Number.parseInt(item.xebz) : '';
                            this.form.stepOneArr[index].hansjeType = item.hansbz == "0" ? false:true;
                            this.form.stepOneArr[index].qdbz = item.qdbz == "1" ? true:false;
                            this.form.jsbbx = item.jsbbx;
                            this.form.djslbbx = item.djslbbx
                            this.form.sljd = item.sljd
                            this.form.djjd = item.djjd
                            this.form.yxdslfp = item.yxdslfp == "1" ? true : false;
                            this.form.cffs = item.cffs
                            this.form.cfmx = item.cfmx != null && item.cfmx!= "" ? item.cfmx.split(",") : []
                            this.form.cfmxFlag = this.form.cfmx.length > 0
                        }
                    })
                })
            }
        },
        //格式化添加千位符
        numFormat(num){
            return num.replace(/\d+/, match => match.replace(/(?!^)(?=(\d{3})+$)/g, ','))
        },
        nextStep(){
            if (this.active++ > 2) this.active = 0;
        },
        xianeChange(data,index){
           this.form.stepOneArr[index].hansje = this.xianeSelectOption[data - 1].text;
        },
        cfmxFlagChange(data){
            if (!data) {
                this.form.mxcffs = [];
            }
        },

        save(){
            let data = {jsbbx:this.form.jsbbx,
                djslbbx:this.form.djslbbx,
                sljd:this.form.sljd,
                djjd:this.form.djjd,
                yxdslfp:this.form.yxdslfp ? "1" : "2",
                cffs:this.form.cffs,
                cfmx:this.form.cfmx.toString()};
            let resultData = this.fplxOption.filter(item => item.flag).map((item,index) => {
                    let stepOneData = this.form.stepOneArr[index];
                    stepOneData.hansje = stepOneData.hansje.replaceAll(",","");
                    return Object.assign({},stepOneData,data,{guizlxbh:stepOneData.guizlxbh,qdbz:stepOneData.qdbz ? "1" : "2",xebz:stepOneData.xiane,hansbz: stepOneData.hansjeType? "1":"0",fplxs:item.value,guizlxmc:item.label + "基础规则",shifyx:"1",ruleType:"0"})
            });
            if (resultData.length == 0) {
                this.$message.error("请至少操作一种发票")
                return;
            }
            this.$emit('saveBaseRuleData',resultData);
        },

        closeDialog(){
            this.$emit('closeDialog');
        }
    },
};
</script>

<style scoped>

</style>